// The legal entity behind the MediaVerse Labs trading name.
//
// A UK company trading under a name other than its registered one has to show the
// registered name, company number and registered office on its websites (Companies
// Act 2006 s.82 and the 2015 Trading Disclosures Regulations). Keeping the details
// here means the footer, the legal pages and the JSON-LD can never drift apart.
//
// Verified against the Companies House register, September 2026.

export const COMPANY = {
  legalName: 'Eager Dragon Publishing Ltd',
  tradingName: 'MediaVerse Labs',
  number: '14697664',
  jurisdiction: 'England and Wales',
  address: {
    line1: '20-22 Wenlock Road',
    city: 'London',
    postcode: 'N1 7GU',
    country: 'United Kingdom',
    countryCode: 'GB',
  },
  email: 'hello@mediaverselabs.com',
};

export const addressOneLine = [
  COMPANY.address.line1,
  COMPANY.address.city,
  COMPANY.address.postcode,
  COMPANY.address.country,
].join(', ');

// The sentence that has to appear wherever the trading name stands alone.
export const disclosure =
  `${COMPANY.tradingName} is a trading name of ${COMPANY.legalName}, ` +
  `a company registered in ${COMPANY.jurisdiction} (company number ${COMPANY.number}). ` +
  `Registered office: ${addressOneLine}.`;
